import { type Meta } from '../types/docs';

type MetaParam = NonNullable<Meta['params']>[number];

export const CANVAS_LIFECYCLE_ANNOUNCEMENT_ID_META_PARAM = {
  description:
    'The id of the announcement that opened this canvas. Omitted when the canvas was not opened from an announcement.',
  name: 'announcement_id',
  required: false,
  type: 'string',
} satisfies MetaParam;
